// Meeting call register: roll call with automatic fines.
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-hot-toast';
import api from '../utils/axios.ts';
import getApiErrorMessage from '../utils/helper.js';

export interface CallRegisterEntry {
  member_id: number;
  status: 'present' | 'absent' | 'late' | 'excused';
  violation_type?: string | null;
  amount?: number | null;
  reason?: string | null;
}

export const useCallRegister = (meetingId: number | null) =>
  useQuery({
    queryKey: ['call-register', meetingId],
    queryFn: async () => (await api.get(`/meetings/${meetingId}/call-register`)).data.data,
    enabled: !!meetingId,
  });

export const useSaveCallRegister = (meetingId: number | null) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (entries: CallRegisterEntry[]) => (await api.post(`/meetings/${meetingId}/call-register`, { entries })).data,
    onSuccess: (data) => {
      toast.success(data?.message || 'Call register saved');
      queryClient.invalidateQueries({ queryKey: ['call-register', meetingId] });
      queryClient.invalidateQueries({ queryKey: ['meetings'] });
      queryClient.invalidateQueries({ queryKey: ['fines'] });
    },
    onError: (error: any) => toast.error(getApiErrorMessage(error) || 'Could not save the call register'),
  });
};
